import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export function usePhotographyAccess() {
  const { user, loading: authLoading } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["photography-access", user?.id],
    queryFn: async () => {
      if (!user) return false;

      const { data, error } = await supabase
        .from("profiles")
        .select("has_photography_access")
        .eq("id", user.id)
        .single();

      if (error) {
        console.error("Error checking photography access:", error);
        return false;
      }

      return data?.has_photography_access || false;
    },
    enabled: !!user,
    staleTime: 10 * 60 * 1000,
  });

  return { 
    hasAccess: data ?? false, 
    loading: authLoading || isLoading 
  };
}
